import { Compass, Home } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * 404 page rendered for any route not matched by a feature's route
 * tree. Customers land here only via deep-link bookmarks that no
 * longer resolve — Workfront's iframe always opens at `/`.
 */
export function NotFoundPage(): JSX.Element {
  return (
    <div className="relative z-10 flex min-h-[calc(100vh-7rem)] items-center justify-center p-6">
      <div className="max-w-md rounded-2xl border border-foreground/15 bg-foreground/[0.03] p-8 text-center">
        <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-foreground/5">
          <Compass className="h-6 w-6 text-[color:var(--brand-yellow)]" />
        </div>
        <h1 className="mb-2 text-3xl font-light text-foreground">Page not found</h1>
        <p className="mb-6 text-sm text-foreground/60">
          The page you requested isn&apos;t part of the WorkFocus customer app. The most likely
          cause is a stale bookmark or a URL typed by hand.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-md border border-foreground/15 bg-foreground/5 px-4 py-2 text-sm text-foreground/80 transition-colors hover:border-[color:var(--brand-yellow)] hover:text-foreground"
        >
          <Home className="h-4 w-4" /> Back to home
        </Link>
      </div>
    </div>
  );
}
